import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Button from "../Button";

interface NavigationBackProps {
  onBeforeGoBack?: () => void;
}

const NavigationBack: React.FC<NavigationBackProps> = ({ onBeforeGoBack }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleClick = () => {
    if (onBeforeGoBack) {
      onBeforeGoBack();
    }
    history.goBack();
  };

  return <Button title={t("navigate_back")} icon={<ArrowBackIcon />} onClick={handleClick} />;
};

export default NavigationBack;
